import { render, staticRenderFns } from "./MainMenuItem.vue?vue&type=template&id=ba88f6ca&"
import script from "./MainMenuItem.vue?vue&type=script&lang=js&"
export * from "./MainMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuItem.vue?vue&type=style&index=0&module=true&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./MainMenuItem.vue?vue&type=style&index=0&module=true&lang=css&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./MainMenuItem.vue?vue&type=style&index=0&module=true&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js").rerender("ba88f6ca")
            }
          }
        })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba88f6ca')) {
      api.createRecord('ba88f6ca', component.options)
    } else {
      api.reload('ba88f6ca', component.options)
    }
    module.hot.accept("./MainMenuItem.vue?vue&type=template&id=ba88f6ca&", function () {
      api.rerender('ba88f6ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainMenuItem.vue"
export default component.exports